import { useQuery } from "@tanstack/react-query";
import type { StorageLocationSearchReq } from "adl-gen/ferovinum/app/api";
import { adlMapToMap } from "utils/adl-utils";
import { useAppService } from "../../use-app-service";
import { storageLocationKeys } from "../query-keys";

export const useGetStorageLocationProductHoldings = (
  req: StorageLocationSearchReq,
) => {
  const service = useAppService();

  return useQuery({
    queryKey: storageLocationKeys.getStorageLocationProductHoldings(
      req.storageLocationId,
      req.searchTerm ?? "",
    ),
    queryFn: async () => {
      const resp = await service.getStorageLocationProductHoldings(req);
      return adlMapToMap(resp);
    },
  });
};
